export var CheckboxGroup = {
    'zh-CN': {
        title: '复选框组',
    },
    'en-US': {
        title: 'Checkbox',
    },
};
